<template>
	<!-- 中间图表区域 -->
	<div class="middlePC" style="
		flex: 1;
		height: 770px;
		background: var(--card-bg);
		transition: background-color 0.3s ease;
		border-radius: 12px;
		margin: 0 10px;
		box-shadow: 0 2px 8px rgba(0,0,0,0.03);
		border: 1px solid rgba(0, 0, 0, 0.02);
		position: relative;
		min-width: 650px;
		overflow: hidden;
		margin-top: 18px;
	">
		<!-- 技术指标面板 -->
		<div v-if="showIndicators" class="indicators-panel">
			<div class="indicators-header">
				<span style="font-size: 14px; font-weight: 500; color: var(--text-primary);">{{ $t('Trading.technicalIndicators') || 'Technical Indicators' }}</span>
				<button class="close-btn" @click="handleCloseIndicators">×</button>
			</div>
			<div class="indicators-content">
				
				<!-- 主图指标 -->
				<div class="indicator-section">
					<div class="section-title">{{ $t('Market.H5.mainIndicator') || '主图指标' }}</div>
					<div class="indicators-list">
						<div
							v-for="indicator in mainIndicators"
							:key="indicator.name"
							class="indicator-item"
							@click="handleToggleIndicator(indicator)"
						>
							<div class="klinecharts-pro-checkbox" :class="{ 'checked': indicator.selected }">
								<svg viewBox="0 0 1024 1024" class="icon">
									<path v-if="!indicator.selected" d="M245.333333 128h533.333334A117.333333 117.333333 0 0 1 896 245.333333v533.333334A117.333333 117.333333 0 0 1 778.666667 896H245.333333A117.333333 117.333333 0 0 1 128 778.666667V245.333333A117.333333 117.333333 0 0 1 245.333333 128z m0 64c-29.44 0-53.333333 23.893333-53.333333 53.333333v533.333334c0 29.44 23.893333 53.333333 53.333333 53.333333h533.333334c29.44 0 53.333333-23.893333 53.333333-53.333333V245.333333c0-29.44-23.893333-53.333333-53.333333-53.333333H245.333333z"></path>
									<path v-else d="M810.666667 128H213.333333c-46.933333 0-85.333333 38.4-85.333333 85.333333v597.333334c0 46.933333 38.4 85.333333 85.333333 85.333333h597.333334c46.933333 0 85.333333-38.4 85.333333-85.333333V213.333333c0-46.933333-38.4-85.333333-85.333333-85.333333z m-353.706667 567.04a42.496 42.496 0 0 1-60.16 0L243.626667 541.866667c-8.106667-8.106667-12.373333-18.773333-12.373334-29.866667s4.693333-22.186667 12.373334-29.866667a42.496 42.496 0 0 1 60.16 0L426.666667 604.586667l293.546666-293.546667a42.496 42.496 0 1 1 60.16 60.16l-323.413333 323.84z"></path>
								</svg>
								<span class="label">{{ $t('Indicators.' + indicator.name) || indicator.name }}</span>
							</div>
						</div>
					</div>
				</div>
				
				<!-- 副图指标 -->
				<div class="indicator-section">
					<div class="section-title">{{ $t('Market.H5.subIndicator') || '副图指标' }}</div>
					<div class="indicators-list">
						<div
							v-for="indicator in subIndicators"
							:key="indicator.name"
							class="indicator-item"
							@click="handleToggleIndicator(indicator)"
						>
							<div class="klinecharts-pro-checkbox" :class="{ 'checked': indicator.selected }">
								<svg viewBox="0 0 1024 1024" class="icon">
									<path v-if="!indicator.selected" d="M245.333333 128h533.333334A117.333333 117.333333 0 0 1 896 245.333333v533.333334A117.333333 117.333333 0 0 1 778.666667 896H245.333333A117.333333 117.333333 0 0 1 128 778.666667V245.333333A117.333333 117.333333 0 0 1 245.333333 128z m0 64c-29.44 0-53.333333 23.893333-53.333333 53.333333v533.333334c0 29.44 23.893333 53.333333 53.333333 53.333333h533.333334c29.44 0 53.333333-23.893333 53.333333-53.333333V245.333333c0-29.44-23.893333-53.333333-53.333333-53.333333H245.333333z"></path>
									<path v-else d="M810.666667 128H213.333333c-46.933333 0-85.333333 38.4-85.333333 85.333333v597.333334c0 46.933333 38.4 85.333333 85.333333 85.333333h597.333334c46.933333 0 85.333333-38.4 85.333333-85.333333V213.333333c0-46.933333-38.4-85.333333-85.333333-85.333333z m-353.706667 567.04a42.496 42.496 0 0 1-60.16 0L243.626667 541.866667c-8.106667-8.106667-12.373333-18.773333-12.373334-29.866667s4.693333-22.186667 12.373334-29.866667a42.496 42.496 0 0 1 60.16 0L426.666667 604.586667l293.546666-293.546667a42.496 42.496 0 1 1 60.16 60.16l-323.413333 323.84z"></path>
								</svg>
								<span class="label">{{ $t('Indicators.' + indicator.name) || indicator.name }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 图表容器 -->
		<div id="container" style="height: calc(100% - 10px); padding: 5px; position: relative;">
			<!-- OHLC信息和指标显示 - 直接显示在K线图上方，无背景 -->
			<div v-if="currentOHLC.time || currentOHLC.open" style="position: absolute; top: 30px; left: 15px; right: 15px; z-index: 10; pointer-events: none;">
				<!-- OHLC信息 -->
				<div class="ohlc-info" style="display: flex; align-items: center; gap: 15px; font-size: 12px; color: var(--text-primary);">
					<div style="font-weight: 500;">{{ $t('Trading.time') || 'Time' }}: <span style="color: var(--text-secondary);">{{ currentOHLC.time }}</span></div>
					<div style="font-weight: 500;">{{ $t('Trading.open') || 'Open' }}: <span style="color: var(--text-secondary);">{{ currentOHLC.open }}</span></div>
					<div style="font-weight: 500;">{{ $t('Trading.high') || 'High' }}: <span style="color: var(--primary-color, #0156DC);">{{ currentOHLC.high }}</span></div>
					<div style="font-weight: 500;">{{ $t('Trading.low') || 'Low' }}: <span style="color: var(--danger-color, #f23c48);">{{ currentOHLC.low }}</span></div>
					<div style="font-weight: 500;">{{ $t('Trading.close') || 'Close' }}: <span style="color: var(--text-secondary);">{{ currentOHLC.close }}</span></div>
					<div style="margin-left: auto; display: flex; align-items: center; gap: 15px;">
						<div style="font-weight: bold; color: var(--text-primary); font-size: 14px;">{{ currentOHLC.currentPrice || '' }}</div>
						<div style="font-weight: bold; color: var(--text-primary); font-size: 12px;">{{ selectedStock ? (selectedStock.appName || selectedStock.show_name || selectedStock.code) : '' }}</div>
					</div>
				</div>
			</div>
			
			<!-- 主图容器 -->
			<div id="k-line-chart" :style="{ width: '100%', height: hasSelectedSubIndicators ? 'calc(100% - 200px)' : '100%' }">
				<div id="trading-chart" style="width: 100%; height: 100%;"></div>
			</div>
			
			<!-- 副图容器 -->
			<div v-if="hasSelectedSubIndicators" id="sub-chart-container" style="width: 100%; height: 200px; padding: 10px; border-top: 1px solid #e8e8e8;">
				<div id="sub-chart" style="width: 100%; height: 100%;"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'KLineChart',
	props: {
		selectedStock: {
			type: Object,
			default: null
		},
		showIndicators: {
			type: Boolean,
			default: false
		},
		mainIndicators: {
			type: Array,
			default: () => []
		},
		subIndicators: {
			type: Array,
			default: () => []
		},
		currentOHLC: {
			type: Object,
			default: () => ({
				time: '',
				open: '',
				high: '',
				low: '',
				close: '',
				currentPrice: ''
			})
		}
	},
	computed: {
		// 是否有选中的副图指标
		hasSelectedSubIndicators() {
			return this.subIndicators && this.subIndicators.some(item => item.selected);
		},
		
		// 选中的主图指标
		selectedMainIndicators() {
			return this.mainIndicators.filter(item => item.selected);
		}
	},
	methods: {
		// 关闭技术指标面板
		handleCloseIndicators() {
			this.$emit('close-indicators');
		},
		
		// 切换指标
		handleToggleIndicator(indicator) {
			this.$emit('toggle-indicator', indicator);
		}
	}
};
</script>

<style scoped>
.middlePC {
	flex: 1;
	height: 770px;
	background: var(--card-bg);
	transition: background-color 0.3s ease;
	border-radius: 8px;
	margin: 0 10px;
	box-shadow: 0 2px 8px rgba(0,0,0,0.03);
	border: 1px solid rgba(0, 0, 0, 0.02);
	position: relative;
	min-width: 650px;
	overflow: hidden;
	margin-top: 18px;
}

/* 技术指标面板 */
.indicators-panel {
	position: absolute;
	top: 15px; /* ✅ 贴近顶部 */
	left: 20px;
	width: 280px;
	max-height: 500px;
	background: var(--card-bg);
	border: 1px solid rgba(0, 0, 0, 0.04);
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
	z-index: 1000;
	overflow: hidden;
}

.indicators-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	background: var(--card-bg); /* ✅ 改为白色背景 */
	/* ✅ 去除下边框线 */
}

.close-btn {
	background: none;
	border: none;
	font-size: 24px;
	color: var(--text-secondary);
	cursor: pointer;
	padding: 0;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.2s;
}

.close-btn:hover {
	color: var(--text-primary);
	background: var(--bg-hover);
	border-radius: 4px;
}

.indicators-content {
	max-height: 420px;
	overflow-y: auto;
	padding: 12px 0;
}

.indicator-section {
	margin-bottom: 16px;
}

.section-title {
	font-size: 13px;
	font-weight: 600;
	color: var(--text-primary);
	padding: 8px 16px;
	background: var(--card-bg); /* ✅ 改为白色背景 */
}

.indicators-list {
	padding: 8px 0;
}

.indicator-item {
	padding: 8px 16px;
	cursor: pointer;
	transition: all 0.2s;
}

.indicator-item:hover {
	background: var(--bg-hover);
}

.klinecharts-pro-checkbox {
	display: flex;
	align-items: center;
	gap: 8px;
	user-select: none;
}

.klinecharts-pro-checkbox .icon {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
}

.klinecharts-pro-checkbox.checked .icon {
	fill: var(--primary-color);
}

.klinecharts-pro-checkbox .label {
	font-size: 14px;
	color: var(--text-primary);
}

/* OHLC信息样式 - 已移至内联样式 */
</style>

